import { ICargoType } from '../entities/cargoesData'
import { monsters } from '../monsters/monsters-sidecar'
import { distance } from '../lib/distance-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { createTask_moveTo } from './taskMoveTo'

export function createTask_deliverCargo(
  i: number,
  j: number,
  cargoType: ICargoType,
  isInsideShip: boolean,
  allowNextTo: boolean = false,
): ITask {
  return jobs._createTask(i, j, 'deliver-cargo', {
    allowFromStack: false,
    cargoType,
    isInsideShip,
    allowNextTo,
  })
}

export function runTaskDeliverCargo(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'deliver-cargo')
  let m = jobLogger.assertReserved(job)

  if (jobLogger.runSubtasks(job, task)) {
    return
  }

  if (jobLogger.isWaitingForPathOrMovement(job)) {
    return
  }

  // Are we not carrying anything?
  if (!m.carryingCargo) {
    return jobLogger.failTask(job, task, 'not carrying cargo')
  }

  // Are we carrying the wrong thing?
  if (m.carryingCargo.data.type !== task.cargoType) {
    monsters.dropCargo(m)
    return jobLogger.failTask(job, task, 'carrying wrong cargo')
  }

  if (distance.isAt(m.i, m.j, task.i, task.j)) {
    // We are here!
    monsters.dropCargo(m)
    return jobLogger.succeedTask(job, task)
  }

  if (task.allowNextTo) {
    if (distance.isNextToIJ(m, task)) {
      // We are here!
      monsters.dropCargo(m)
      return jobLogger.succeedTask(job, task)
    }
  }

  task.subtasks.push(
    createTask_moveTo(task.i, task.j, task.isInsideShip, task.allowNextTo),
  )

  // // Find path to delivery spot!
  // job.findPathId = pathFinder.findPath(
  //   m.i,
  //   m.j,
  //   task.i,
  //   task.j,
  //   m.isInsideShip,
  //   (path) => {
  //     job.findPathId = 0
  //     if (!task) {
  //       throw new Error('lost our task!')
  //     }

  //     if (!path || path.length === 0) {
  //       task.isFailed = true
  //       task.isComplete = true
  //     } else {
  //       if (m) {
  //         monsters.setPath(m, path)
  //       }
  //     }
  //   },
  // )
}
